<template>
    <div id="nav-container" class="mx-auto bg-white p-4 rounded">
        <!-- Progress bar -->
        <div class="w-full mb-1 relative">
            <div class="w-full h-6 bg-gray-200 rounded-full relative">
                <div class="h-6 bg-vert rounded-full" :style="{
                    width: page === 'start' ? '10%' : (page === 'intervention' ? '50%' : '100%')
                }">
                </div>
                <a href="javascript: void 0" class="w-16 h-16 bg-transparent rounded-full absolute -top-5 left-0"
                    @click="$emit('changeSection', 'start')"></a>
                <a href="javascript: void 0"
                    class="w-16 h-16 bg-transparent rounded-full absolute -top-5 left-1/2 -translate-x-1/2"
                    @click="$emit('changeSection', 'intervention')"></a>
                <a href="javascript: void 0"
                    class="w-16 h-16 bg-transparent rounded-full absolute -top-5 -translate-x-1/2"
                    @click="$emit('changeSection', 'finish')" style="right: -32px;"></a>

            </div>
            <!-- Step labels -->
            <div class="flex justify-between text-xs font-bold px-1 mt-1 select-none sm:text-sm">
                <div class="text-left">NATURE</div>
                <div class="text-center">INTERVENTION</div>
                <div class="text-right">SIGNATURE</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type: String,
            default: 'start'
        }
    }
}
</script>



// WEBPACK FOOTER //
// Nav.vue?6a5110b0